import {useQuery} from "react-query";
import OnTimeArrivalApi from "./OnTimeArrival.api";
import { IWidgetQuery } from "../Base/Base.types";

export function useOnTimeArrival(query:IWidgetQuery){
    return useQuery(["fetchOnTimeArrival", query], OnTimeArrivalApi.getData);
}